import { createReducer } from '@reduxjs/toolkit';

import { type IWarehouseState } from './types';

export const preloadedState: IWarehouseState = {
  warehouses: undefined,
};

export default createReducer(preloadedState, () => {});
